/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import { bool, func } from 'prop-types'
import { Controller } from 'react-hook-form'

import {
  Modal as TriagleModal,
  TextInput,
  RadioButtonsGroup,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { useCouponForm } from 'Pods/MySalesNew/Hooks/useCouponForm'

function Modal({ isModalOpen, setIsModalOpen, handleCreateCoupon }) {
  const {
    control,
    errors,
    discountType,
    handleFormSubmit,
  } = useCouponForm(handleCreateCoupon, setIsModalOpen, isModalOpen)

  return (
    <TriagleModal
      header="New coupon"
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      primaryAction={{
        buttonProps: {
          onClick: handleFormSubmit,
        },
        content: 'Create',
      }}
      width="small"
      secondaryAction={{
        buttonProps: {
          onClick: () => setIsModalOpen(false),
        },
        content: 'Cancel',
      }}
      customClass="coupon-modal"
    >
      <div>
        <div className="cgt-mt-20">
          <Controller
            name="code"
            control={control}
            rules={{
              required: {
                value: true,
                message: 'Code is required',
              },
              pattern: {
                value: /^[A-Z0-9]*$/,
                message: 'Code should contain only capital letters and numbers',
              },
            }}
            render={({ field }) => (
              <TextInput
                beforeInput={null}
                id="code"
                isPilot
                label="Code"
                placeholder="NEWYEAR20"
                size="medium"
                type="primary"
                onChange={(e) => field.onChange(e.target.value)}
                value={field.value}
                helpText={errors.code?.message}
                isWarning={!!errors.code}
              />
            )}
          />
        </div>

        <div className="cgt-mt-20">
          <Controller
            name="validUntil"
            control={control}
            rules={{
              required: {
                value: true,
                message: 'Valid until is required',
              },
              pattern: {
                value: /^\d{4}-\d{2}-\d{2}$/,
                message: 'Please enter a valid date in the format YYYY-MM-DD',
              },
            }}
            render={({ field }) => (
              <TextInput
                beforeInput={null}
                id="valid-until"
                isPilot
                label="Valid until"
                placeholder="Enter date"
                size="medium"
                type="primary"
                onChange={(e) => field.onChange(e.target.value)}
                value={field.value}
                helpText={errors.validUntil?.message}
                isWarning={!!errors.validUntil}
              />
            )}
          />
        </div>

        <div className="cgt-mt-20">
          <Controller
            name="maxTimesCanBeUsed"
            control={control}
            rules={{
              required: {
                value: true,
                message: 'Max. times can be used is required',
              },
              pattern: {
                value: /^[0-9]*$/,
                message: 'Please enter a valid number',
              },
            }}
            render={({ field }) => (
              <TextInput
                beforeInput={null}
                id="max-times-can-be-used"
                isPilot
                label="Max. times can be used"
                placeholder="Enter number"
                size="medium"
                type="primary"
                onChange={(e) => field.onChange(e.target.value)}
                value={field.value}
                helpText={errors.maxTimesCanBeUsed?.message}
                isWarning={!!errors.maxTimesCanBeUsed}
              />
            )}
          />
        </div>

        <div className="cgt-mt-20">
          <Controller
            name="discountType"
            control={control}
            render={({ field }) => (
              <RadioButtonsGroup
                options={[
                  {
                    label: '% Percentage',
                    value: 'percentage',
                    key: 'percentage',
                  },
                  { label: 'Rebate', value: 'rebate', key: 'rebate' },
                ]}
                name="regular-discounts"
                value={field.value}
                onChange={field.onChange}
                color="custom-active-button"
                componentType="div"
                label="Type of discount"
                wrapperClass="coupon-modal__radio-group"
              />
            )}
          />
        </div>

        <div className="cgt-mt-20">
          <Controller
            name="discountAmount"
            control={control}
            rules={{
              required: {
                value: true,
                message: 'Discount amount is required',
              },
              pattern: {
                value: /^[0-9]*(\.[0-9]{1,2})?$/,
                message: 'Please enter a valid number',
              },
              validate: {
                validAmount: (value) => {
                  if (discountType === 'percentage') {
                    const amount = parseFloat(value)
                    return (
                      Number.isNaN(amount) || amount <= 100 || 'Percentage discount cannot be greater than 100%'
                    )
                  }
                  if (discountType === 'rebate') {
                    const amount = parseFloat(value)
                    return amount > 0 || 'Rebate amount must be greater than 0'
                  }
                  return true
                },
              },
            }}
            render={({ field }) => (
              <TextInput
                beforeInput={null}
                id="discount-amount"
                isPilot
                label="Discount amount"
                size="medium"
                type="primary"
                onChange={(e) => field.onChange(e.target.value)}
                value={field.value}
                isWarning={!!errors.discountAmount}
                helpText={errors.discountAmount?.message}
              />
            )}
          />
        </div>
      </div>
    </TriagleModal>
  )
}

Modal.propTypes = {
  isModalOpen: bool.isRequired,
  setIsModalOpen: func.isRequired,
  handleCreateCoupon: func.isRequired,
}

export default Modal
